import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Salesperson } from '@galaxy/types';
import { AccountUrlFunction, CompanyUrlFunction, DetailsConfig } from '../../sales-opportunities/opportunity';

export const PIPELINE_CARD_CONFIG_TOKEN = new InjectionToken<PipelineCardConfig>(
  'general dependency data for the pipeline card component',
);
export interface PipelineCardConfig {
  allSalespeople$: Observable<Salesperson[]>; // Should start with current salesperson user when applicable
  defaultCurrency$: Observable<string>;
  opportunityInfoUrlBuilder: OpportunityInfoUrlBuilder;
  detailsConfig: DetailsConfig;
}

export interface OpportunityInfoUrlBuilder {
  (businessId: string, opportunityId: string): string;
}
export const ALL_SALESPEOPLE: InjectionToken<Observable<Salesperson[]>> = new InjectionToken(
  'token for list of all salespeople',
);
export const DEFAULT_CURRENCY: InjectionToken<Observable<string>> = new InjectionToken('token for default currency');
export const OPPORTUNITY_INFO_URL_BUILDER: InjectionToken<OpportunityInfoUrlBuilder> = new InjectionToken(
  'token for function to build opportunity info url path',
);
export const ACCOUNT_DETAILS_URL_TOKEN: InjectionToken<AccountUrlFunction> = new InjectionToken(
  'token for account details URL generator',
);
export const COMPANY_DETAILS_URL_TOKEN: InjectionToken<CompanyUrlFunction> = new InjectionToken(
  'token for the company details URL generator',
);

export const DETAILS_CONFIG_TOKEN = new InjectionToken<DetailsConfig>(
  'token for configuring whether to show details in the account group or the company',
);
